<script>
  import { slide } from 'svelte/transition'

  let { query = '', data = [] } = $props()

  // Find the selected node
  const selectedNode = $derived(data.find((d) => d['bto-name'] === query))

  const probability = $derived(selectedNode ? parseFloat(selectedNode.Probability_BTO) : null)

  function formatReasons(reasons) {
    if (reasons.length === 0) {
      return 'It does not match any of the common naming patterns found in HDB or condo estates.'
    }
    if (reasons.length === 1) {
      return `It has ${reasons[0]} in its name.`
    }
    if (reasons.length === 2) {
      return `It has ${reasons[0]} and ${reasons[1]} in its name.`
    }
    const allButLast = reasons.slice(0, -1).join(', ')
    const last = reasons[reasons.length - 1]
    return `It has ${allButLast} and ${last} in its name.`
  }

  // Determine descriptions based on Probability_BTO and column signals
  const resultData = $derived.by(() => {
    if (probability === null || isNaN(probability) || !selectedNode) {
      return {
        sentence1: 'reads straight out of the HDB naming playbook.',
        sentence2: 'It has an MRT or town in its name.',
      }
    }

    // 1. Determine first sentence
    let sentence1 = ''
    const is043 = probability.toFixed(2) === '0.43'

    if (is043) {
      sentence1 = 'could pass off as either.'
    } else if (probability >= 0 && probability <= 0.3) {
      sentence1 = 'sounds straight out of a condo brochure.'
    } else if (probability >= 0.31 && probability <= 0.5) {
      sentence1 = 'leans more condo.'
    } else if (probability >= 0.51 && probability <= 0.8) {
      sentence1 = 'leans more towards a HDB estate.'
    } else if (probability >= 0.81 && probability <= 1) {
      sentence1 = 'reads straight out of the HDB naming playbook.'
      // } else {
      //   // Fallbacks for gaps
      //   if (probability < 0.07) {
      //     sentence1 = 'sounds straight out of a condo brochure.'
      //   } else if (probability > 0.97) {
      //     sentence1 = 'reads straight out of the HDB naming playbook.'
      //   } else {
      //     sentence1 = 'could pass off as either.'
      //   }
    }

    // 2. Determine second sentence
    let sentence2 = ''
    if (is043) {
      sentence2 =
        'It does not match any of the common naming patterns found in HDB or condo estates.'
    } else if (probability > 0.51) {
      // BTO signals only
      const activeReasons = []
      if (selectedNode.mrt_or_town === true || selectedNode.mrt_or_town === 'true') {
        activeReasons.push('an MRT or town')
      }
      if (selectedNode['has_@'] === true || selectedNode['has_@'] === 'true') {
        activeReasons.push('an “@” symbol')
      }
      if (selectedNode.has_compound === true || selectedNode.has_compound === 'true') {
        activeReasons.push('a compound word')
      }
      sentence2 = formatReasons(activeReasons)
    } else if (probability < 0.5) {
      // Condo signals only
      const activeReasons = []
      if (selectedNode.has_the === true || selectedNode.has_the === 'true') {
        activeReasons.push('“the”')
      }
      if (selectedNode.has_numeral === true || selectedNode.has_numeral === 'true') {
        activeReasons.push('numerals')
      }
      if (selectedNode.has_romance_lang === true || selectedNode.has_romance_lang === 'true') {
        activeReasons.push('a romance word')
      }
      if (selectedNode.all_rare === true || selectedNode.all_rare === 'true') {
        activeReasons.push('a rare word')
      }
      if (selectedNode.one_word === true || selectedNode.one_word === 'true') {
        activeReasons.push('only one word')
      }
      sentence2 = formatReasons(activeReasons)
    } else {
      // Fallback for [0.50, 0.51] range
      sentence2 =
        'It does not match any of the common naming patterns found in HDB or condo estates.'
    }

    return { sentence1, sentence2 }
  })
</script>

{#if selectedNode}
  <div class="results-container" transition:slide={{ duration: 400 }}>
    <p class="results-text">
      <span class="highlight">{query}</span>
      {resultData.sentence1}
    </p>
    <p class="results-text">
      {resultData.sentence2}
    </p>
    <p class="cta-text">Choose another name or keep scrolling to continue story.</p>
  </div>
{/if}

<style lang="scss">
  .results-container {
    margin-top: 20px;
    color: white;
    font-family: var(--font-sans-serif);
    font-size: clamp(14px, 3.5vw, 16px);
    line-height: 1.3;
    //padding: 0 10px;
    font-size: 15px;
  }

  .results-text {
    margin-bottom: 12px;
    font-weight: 300;
  }

  .highlight {
    color: var(--project-highlight-color, #cfff5e);
    font-family: CuratorBold, var(--font-sans-serif);
    font-weight: bold;
  }

  .cta-text {
    margin-top: 18px;
    color: rgba(255, 255, 255, 0.7);
    // font-size: clamp(13px, 3vw, 15px);
    font-size: 15px;
  }
</style>
